import {ProposalAbstractState} from '@Containers/builder-abstract-page/builder-abstract.route.js';
import {
	AccessoriesInspectorState,
	AccessoriesState,
} from '@Containers/builder-accessories-page/accessories.route.js';
import {CustomerCreateState, CustomerState} from '@Containers/builder-customer-page/customer.route.js';
import {BuilderInspectorState, BuilderState} from '@Containers/builder-equipment-page/equipment.route.js';
import {
	InstallationInspectorState,
	InstallationState,
} from '@Containers/builder-installation-page/installation.route.js';
import {SummaryInspectorState, SummaryState} from '@Containers/builder-summary-page/summary.route.js';
import {SurveyWithParamsState} from '@Containers/builder-survey-page/survey.route.js';
import {
	NavigatorDetailsState,
	NavigatorInspectorState,
	NavigatorState,
} from '@Containers/navigator-page/navigator.route.js';
import {OfficeAbstractState} from '@Containers/office-abstract-page/office-abstract.route.js';
import {OfficeAccessoriesCustomCreateState} from '@Containers/office-accessories-page/custom-create/custom-create.route.js';
import {OfficeAccessoriesCustomUpdateState} from '@Containers/office-accessories-page/custom-update/custom-update.route.js';
import {OfficeAccessoriesLiveCreateState} from '@Containers/office-accessories-page/live-create/live-create.route.js';
import {OfficeAccessoriesLiveUpdateState} from '@Containers/office-accessories-page/live-update/live-update.route.js';
import {OfficeAccessoriesListState} from '@Containers/office-accessories-page/office-accessories.route.js';
import {OfficeAccessoriesSearchLiveState} from '@Containers/office-accessories-page/search-live/office-accessories-search-live.route.js';
import {OfficeAlternateEquipmentState} from '@Containers/office-alternate-equipment-page/office-alternate-equipment.route.js';
import {
	OfficeAutopilotCreateState,
	OfficeAutopilotListState,
	OfficeAutopilotUpdateState,
} from '@Containers/office-autopilot-page/office-autopilot.route.js';
import {OfficeBundleManagerState} from '@Containers/office-bundle-manager-page/office-bundle-manager.route.js';
import {OfficeConnectorsState} from '@Containers/office-connectors-page/office-connectors.route.js';
import {OfficeConsultationsListState} from '@Containers/office-consultation-page/office-consultation.route.js';
import {OfficeCustomEquipmentCreateState} from '@Containers/office-custom-equipment-page/office-custom-equipment-create.route.js';
import {OfficeCustomEquipmentListState} from '@Containers/office-custom-equipment-page/office-custom-equipment-list.route.js';
import {OfficeCustomEquipmentUpdateState} from '@Containers/office-custom-equipment-page/office-custom-equipment-update.route.js';
import {OfficeDashboardState} from '@Containers/office-dashboard-page/office-dashboard.route.js';
import {OfficeEmailFollowupState} from '@Containers/office-email-followup-page/office-email-followup.route.js';
import {OfficeEmailTemplatesState} from '@Containers/office-email-template-page/office-email-templates.route.js';
import {OfficeFileImporterState} from '@Containers/office-file-importer/office-file-importer.route.js';
import {OfficeFinanceListState} from '@Containers/office-finance-options/office-finance-list.route.js';
import {OfficeFinancePlusState} from '@Containers/office-finance-options/office-finance-plus.route.js';
import {OfficeFinanceStandardState} from '@Containers/office-finance-options/office-finance-standard.route.js';
import {OfficeFinanceTextState} from '@Containers/office-finance-options/office-finance-text.route.js';
import {OfficeFlexjobsCreateState} from '@Containers/office-flexjobs-page/create/office-flexjobs-create.route.js';
import {OfficeFlexjobsEditState} from '@Containers/office-flexjobs-page/edit/office-flexjobs-edit.route.js';
import {OfficeFlexjobState} from '@Containers/office-flexjobs-page/office-flexjob.route.js';
import {OfficeCreateInstallationState} from '@Containers/office-installation-page/office-create-installation/office-create-installation.route.js';
import {OfficeEditInstallationState} from '@Containers/office-installation-page/office-edit-installation/office-edit-installation.route.js';
import {OfficeInstallationListState} from '@Containers/office-installation-page/office-installation-list.route.js';
import {OfficeLiveEquipmentState} from '@Containers/office-live-equipment-page/office-live-equipment.route.js';
import {OfficeCompanyProfileState} from '@Containers/office-my-company-page/office-my-company.route.js';
import {OfficePricingState} from '@Containers/office-pricing-engine/office-pricing.route.js';
import {OfficeConsultationSettingsState} from '@Containers/office-consultation-settings/office-consultation-settings.route.js';
import {OfficeProposalLabelsState} from '@Containers/office-proposal-labels/office-proposal-labels.route.js';
import {OfficeCreateEditDiscountState} from '@Containers/office-rebate-discounts-page/office-create-edit-discount/office-create-edit-discount.route.js';
import {OfficeCreateEditRebateState} from '@Containers/office-rebate-discounts-page/office-create-edit-rebate/office-create-edit-rebate.route.js';
import {OfficeRebDisListState} from '@Containers/office-rebate-discounts-page/office-rebate-discounts.route.js';
import {OfficeReportsState} from '@Containers/office-reports-page/office-reports.route.js';
import {OfficeSurveyState} from '@Containers/office-survey-page/office-survey.route.js';
import {OfficeUserCreateState} from '@Containers/office-users-page/create/office-user-create.route.js';
import {OfficeUsersListState} from '@Containers/office-users-page/office-users-list.route.js';
import {OfficeUserUpdate} from '@Containers/office-users-page/update/office-user-update.route.js';
import {PreviewAbstractState} from '@Containers/preview-abstract-page/preview-abstract.route.js';
import {PreviewAcceptedState} from '@Containers/preview-accepted-page/preview-accepted.route.js';
import {PreviewConsultationState} from '@Containers/preview-consultation-page/preview-consultation.route.js';
import {PreviewInspectorState} from '@Containers/preview-inspector-page/preview-inspector.route.js';
import {PreviewLostState} from '@Containers/preview-lost-page/preview-lost.route.js';
import {PreviewProposalState} from '@Containers/preview-proposal-page/preview-proposal.route.js';
import {PrintAbstractState} from '@Containers/print-abstract-page/print-abstract.route.js';
import {PrintPublicState, PrintPrivateState} from '@Containers/print-proposal-page/print.route.js';
import {ViewTestState} from '@Containers/test-page/test-page.route.js';
import {UserAbstractState} from '@Containers/user-abstract-page/user-abstract.route.js';
import {UserAuthState} from '@Containers/user-auth-page/user-auth.route.js';
import {UserResetPass} from '@Containers/user-change-pass-page/user-reset-pass.route.js';
import {UserForgotPass} from '@Containers/user-forgot-pass-page/user-forgot-pass.route.js';
import {UserInfo} from '@Containers/user-info-page/user-info.route.js';
import {UserLoginState} from '@Containers/user-login-page/user-login.route.js';
import {UserLogoutState} from '@Containers/user-logout-page/user-logout.route.js';
import {UserSetPass} from '@Containers/user-set-pass-page/user-set-pass.route.js';
import {UserSuper} from '@Containers/user-super-page/user-super.route.js';
import {ViewAbstractState} from '@Containers/view-abstract-page/view-abstract.route.js';
import {ViewAcceptedState} from '@Containers/view-accepted-page/view-accepted.route.js';
import {ChargifyState} from '@Containers/view-chargify-page/view-chargify.route.js';
import {ViewConfirmationState} from '@Containers/view-confirmation-page/view-confirmation.route.js';
import {ViewConsultationState} from '@Containers/view-consultation-page/view-consultation.route.js';
import {ViewExpiredState} from '@Containers/view-expired-page/view-expired.route.js';
import {ViewInspectorState} from '@Containers/view-inspector-page/view-inspector.route.js';
import {
	ViewLegacyCustomerAcceptedState,
	ViewLegacyCustomerDetailsState,
	ViewLegacyCustomerSummaryState,
	ViewLegacyState,
} from '@Containers/view-legacy-page/view-legacy.route.js';
import {ViewLostState} from '@Containers/view-lost-page/view-lost.route.js';
import {ViewProposalState} from '@Containers/view-proposal-page/view-proposal.route.js';
import {ViewUnavailableState} from '@Containers/view-unavailable-page/view-unavailable.route.js';
//
const routesConfig = $injector => {
	const $locationProvider = $injector.get('$locationProvider');
	// Configure HTML5 mode with requireBase: false to prevent base tag errors in tests
	$locationProvider.html5Mode({enabled: true, requireBase: false}).hashPrefix('');
	//
	const $stateProvider = $injector.get('$stateProvider');
	$stateProvider
		// #region navigator
		.state('navigator', NavigatorState)
		.state('navigator.details', NavigatorDetailsState)
		.state('navigator.inspector', NavigatorInspectorState)
		// #endregion
		// #region proposal
		.state('proposal', ProposalAbstractState)
		.state('proposal.customer', CustomerState)
		.state('proposal.customerCreate', CustomerCreateState)
		.state('proposal.survey', SurveyWithParamsState)
		.state('proposal.equipment', BuilderState)
		.state('proposal.equipment.inspector', BuilderInspectorState)
		.state('proposal.accessories', AccessoriesState)
		.state('proposal.accessories.inspector', AccessoriesInspectorState)
		.state('proposal.installation', InstallationState)
		.state('proposal.installation.inspector', InstallationInspectorState)
		.state('proposal.summary', SummaryState)
		.state('proposal.summary.inspector', SummaryInspectorState)
		.state('proposal.chargify', ChargifyState)
		// #endregion
		// #region user
		.state('user', UserAbstractState)
		.state('user.auth', UserAuthState)
		.state('user.login', UserLoginState)
		.state('user.logout', UserLogoutState)
		.state('user.setPassword', UserSetPass)
		.state('user.resetpassword', UserResetPass)
		.state('user.forgotPass', UserForgotPass)
		.state('user.info', UserInfo)
		.state('user.super', UserSuper)
		// #endregion
		// #region view
		.state('view', ViewAbstractState)
		.state('view.consultation', ViewConsultationState)
		.state('view.proposal', ViewProposalState)
		.state('view.accepted', ViewAcceptedState)
		.state('view.inspector', ViewInspectorState)
		.state('view.confirmation', ViewConfirmationState)
		.state('view.lost', ViewLostState)
		.state('view.unavailable', ViewUnavailableState)
		.state('view.expired', ViewExpiredState)
		.state('view.legacy', ViewLegacyState)
		// #endregion
		// #region preview
		.state('preview', PreviewAbstractState)
		.state('preview.consultation', PreviewConsultationState)
		.state('preview.proposal', PreviewProposalState)
		.state('preview.accepted', PreviewAcceptedState)
		.state('preview.inspector', PreviewInspectorState)
		.state('preview.lost', PreviewLostState)
		// print
		.state('print', PrintAbstractState)
		.state('print.private', PrintPrivateState)
		.state('print.public', PrintPublicState)
		// #endregion
		// #region legacy emailed comparison, details & accepted
		.state('customersummary', ViewLegacyCustomerSummaryState)
		.state('customerdetails', ViewLegacyCustomerDetailsState)
		.state('customeraccepted', ViewLegacyCustomerAcceptedState)
		// #endregion
		// #region office abstract
		.state('office', OfficeAbstractState)
		// equipment
		.state('office.liveEquipment', OfficeLiveEquipmentState)
		.state('office.alternateEquipment', OfficeAlternateEquipmentState)
		.state('office.bundleManager', OfficeBundleManagerState)
		.state('office.fileImport', OfficeFileImporterState)
		.state('office.customEquipment', OfficeCustomEquipmentListState)
		.state('office.customEquipmentCreate', OfficeCustomEquipmentCreateState)
		.state('office.customEquipmentUpdate', OfficeCustomEquipmentUpdateState)
		// rebates & discounts
		.state('office.rebadisc', OfficeRebDisListState)
		.state('office.rebadiscCreateEditRebate', OfficeCreateEditRebateState)
		.state('office.rebadiscCreateEditDiscount', OfficeCreateEditDiscountState)
		// flexjobs
		.state('office.flexjobs', OfficeFlexjobState)
		.state('office.flexjobsCreate', OfficeFlexjobsCreateState)
		.state('office.flexjobsEdit', OfficeFlexjobsEditState)
		// users
		.state('office.users', OfficeUsersListState)
		.state('office.usersUpdate', OfficeUserUpdate)
		.state('office.usersCreate', OfficeUserCreateState)
		// pricing
		.state('office.economic-profile', OfficePricingState)
		// dashboard
		.state('office.dashboard', OfficeDashboardState)
		// accessories
		.state('office.accessories', OfficeAccessoriesListState)
		.state('office.accessoriesCreateLive', OfficeAccessoriesLiveCreateState)
		.state('office.accessoriesLiveUpdate', OfficeAccessoriesLiveUpdateState)
		.state('office.accessoriesCreateCustom', OfficeAccessoriesCustomCreateState)
		.state('office.accessoriesCustomUpdate', OfficeAccessoriesCustomUpdateState)
		.state('office.accessoriesSearchLive', OfficeAccessoriesSearchLiveState)
		// installation
		.state('office.installation', OfficeInstallationListState)
		.state('office.installationCreate', OfficeCreateInstallationState)
		.state('office.installationEdit', OfficeEditInstallationState)
		// consultations
		.state('office.consultations', OfficeConsultationsListState)
		// autopilot
		.state('office.autopilot', OfficeAutopilotListState)
		.state('office.autopilotCreate', OfficeAutopilotCreateState)
		.state('office.autopilotUpdate', OfficeAutopilotUpdateState)
		// #region settings
		.state('office.company-profile', OfficeCompanyProfileState)
		.state('office.connectors', OfficeConnectorsState)
		.state('office.financeOption', OfficeFinanceListState)
		.state('office.financeOptionStandard', OfficeFinanceStandardState)
		.state('office.financeOptionText', OfficeFinanceTextState)
		.state('office.financeOptionFinancePlus', OfficeFinancePlusState)
		.state('office.settings-proposal-labels', OfficeProposalLabelsState)
		.state('office.settings-consultation', OfficeConsultationSettingsState)
		.state('office.settings-survey', OfficeSurveyState)
		// #region email templates
		.state('office.email-templates', OfficeEmailTemplatesState)
		.state('office.email-followups', OfficeEmailFollowupState)
		// office.reports
		.state('office.reports', OfficeReportsState)
		// test
		.state('test', ViewTestState);
	// #endregion

	const $urlRouterProvider = $injector.get('$urlRouterProvider');
	const AUTH_CB_KEY = $injector.get('AUTH_CB_KEY');
	// in de past: $urlRouterProvider.otherwise('/navigator')
	// deprecated as after html5mode, callback urls like Auth0 logout point to root domain
	// TODO: login callback should be handled also here
	$urlRouterProvider.rule(function () {
		// sample url: https://localhost:3000/?sub=AUTH0_CONNECTOR_CB&id=BK&logout=true
		const search = window.location.search;
		const path = window.location.pathname;
		const params = new URLSearchParams(search);
		const _officeConnectorsUrl = `/office/connectors${search}`;

		if (path === '/' && params.has('sub') && params.get('sub') === AUTH_CB_KEY) {
			return _officeConnectorsUrl;
		}

		if (path === '/') {
			return '/navigator';
		}

		// all other →  do nothing
		return null;
	});
};
routesConfig.$inject = ['$injector'];
export default routesConfig;
